export default {
  'stock_download_title': 'Securities Trading Platform',
  'futures_download_title': 'Futures Trading Platform',
  'fx_Pro_download_title': 'Eddid FX Pro',
  'fx_MT5_download_title': 'MetaTrader5(MT5)',
  'stock_iOS': 'iOS',
  'stock_Android': 'Android',
  'stock_Microsoft': 'Microsoft',
  'stock_web': 'Webpage Version',
  'stock_security_code_ios': 'Security Code (iOS)',
  'stock_security_code_android': 'Security Code (Android)',
  'fx_pro_for_iPhone': 'iOS',
  'fx_pro_for_Android': 'Android',
  'fx_pro_for_Windows_html': 'Windows (Html)',
  'fx_pro_for_Windows_java': 'Windows (Java)',
  'fx_pro_for_java': 'Java',
  'fx_mt5_for_iPhone': 'iOS',
  'fx_mt5_for_Android': 'Android',
  'fx_mt5_for_Windows': 'Windows',
  'fx_mt5_eddid_ios': 'EDDID Account Two-Factor Authentication Software (iOS)',
  'fx_mt5_eddid_android': 'EDDID Account Two-Factor Authentication Software (Android)',
  'futures_download': 'Trading Platform',
  'futures_use_download': 'User Manual',
  'eddid_pro': 'EddidPro',
  'eddid_lite': 'Eddid Lite'
}
